"use client";

import { useMutation as useDeleteHiddenBrandUserFeedback } from "@faire/web-api/api/v2/search/feedback/hide-brand/brandToken/delete-hooks";
import { Row } from "@faire/web/slate/Layout";
import React, { useState } from "react";

import { UserDrivenFeedbackButton } from "@faire/retailer/components/UserFeedback/UserDrivenFeedbackButton";
import { UserDrivenFeedbackProductTileUndoOverlay } from "@faire/retailer/components/UserFeedback/UserDrivenFeedbackProductTileUndoOverlay";
import { useIsLoggedInRetailer } from "@faire/retailer/lib/isLoggedInRetailer";
import { useSettingEnableUserFeedback } from "@faire/retailer/settings/useSettingEnableUserFeedback";

export const MaybeComponentWithUserDrivenFeedbackButton: React.FC<
  React.PropsWithChildren<{
    brandToken?: string;
  }>
> = ({ children, brandToken }) => {
  const isUserLoggedIn = useIsLoggedInRetailer();
  const settingValue = useSettingEnableUserFeedback();
  const [showUndoOverlay, setShowUndoOverlay] = useState(false);
  const { mutate: undoHiddenBrand } = useDeleteHiddenBrandUserFeedback({
    onSuccess: () => setShowUndoOverlay(false),
  });
  if (settingValue && isUserLoggedIn) {
    return (
      <>
        {showUndoOverlay ? (
          <UserDrivenFeedbackProductTileUndoOverlay
            onUndoClick={() => undoHiddenBrand([brandToken ?? ""])}
          />
        ) : null}
        <Row justify="space-between">
          {children}
          <UserDrivenFeedbackButton
            brandToken={brandToken}
            onHideBrandSuccess={() => setShowUndoOverlay(true)}
          />
        </Row>
      </>
    );
  }
  return <>{children}</>;
};
